export const downloadFile = (response, name) => {
  let blob = '';
  blob = response.data;
  const link = document.createElement('a');
  link.href = `data:application/pdf;base64,${blob}`;
  link.download = name;
  link.click();
};
